<script setup lang="ts">
import { computed } from 'vue'
import { LAYER_TYPE_LABELS } from './format'
import type { PendingLayer } from './types'

const props = defineProps<{ layer: PendingLayer }>()

const data = computed(() => props.layer.data ?? {})
</script>

<template>
  <div class="text-xs space-y-0.5">
    <div class="text-muted-foreground font-medium">Request</div>
    <div><span class="text-muted-foreground">Kind:</span> {{ LAYER_TYPE_LABELS[layer.layer_type] || layer.layer_type }}</div>
    <template v-if="layer.layer_type === 'order'">
      <div v-if="data.item_type"><span class="text-muted-foreground">Item type:</span> {{ data.item_type }}</div>
      <div v-if="data.product_bundle"><span class="text-muted-foreground">Bundle:</span> {{ data.product_bundle }}</div>
      <div v-if="data.item_ids"><span class="text-muted-foreground">Items:</span> {{ data.item_ids.length }}</div>
    </template>
    <template v-else-if="layer.layer_type === 'subscription'">
      <div v-if="data.parameters?.id"><span class="text-muted-foreground">Product:</span> {{ data.parameters.id }}</div>
      <div v-if="data.type"><span class="text-muted-foreground">Type:</span> {{ data.type }}</div>
    </template>
    <template v-else-if="layer.layer_type === 'tasking'">
      <div v-if="data.order_type"><span class="text-muted-foreground">Type:</span> {{ data.order_type }}</div>
      <div v-if="data.sat_elevation_angle_min != null"><span class="text-muted-foreground">Elevation:</span> {{ data.sat_elevation_angle_min }}° — {{ data.sat_elevation_angle_max }}°</div>
      <div v-if="data.exclusivity_days != null"><span class="text-muted-foreground">Exclusivity:</span> {{ data.exclusivity_days }} days</div>
    </template>
  </div>
</template>
